import { render, staticRenderFns } from "./packagelist.vue?vue&type=template&id=8b9ea2d4&scoped=true&"
import script from "./packagelist.vue?vue&type=script&lang=js&"
export * from "./packagelist.vue?vue&type=script&lang=js&"
import style0 from "./packagelist.vue?vue&type=style&index=0&id=8b9ea2d4&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b9ea2d4",
  null
  
)

export default component.exports